import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Container,
} from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";

import { Cookies } from "react-cookie";

import AdminCreditHistoryUsed from "./AdminCreditHistoryUsed";
import AdminCreditHistoryPaid from "./AdminCreditHistoryPaid";

import { addCommasToNumber } from "../../../utils/AboutNumber";

const cookies = new Cookies();

function AdminCredit({ isActive }) {
  // const [modalOpen, setModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("크레딧 사용");
  const [summary, setSummary] = useState({ credit: 0, paid: 0 });

  useEffect(() => {
    // 크레딧 리스트 가져오기
    if (isActive) {
      getCredit();
    }
  }, [isActive]);

  const getCredit = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/credit/summary`,
        {
          headers: {
            Authorization: cookies.get("info").token,
          },
        }
      );
      console.log("resList", res.data[0]);
      setSummary(res.data[0]);
    } catch (error) {
      console.error("데이터를 불러오는데 실패했습니다", error);
    }
  };

  return (
    <>
      <Row className="mb-5">
        <Col>
          <div
            className="border p-3 radios text-center"
            style={{ height: "100px" }}
          >
            크레딧 사용금액 : ${addCommasToNumber(Math.abs(summary.used))}
          </div>
        </Col>
        <Col>
          {" "}
          <div
            className="border p-3 radios text-center"
            style={{ height: "100px" }}
          >
            크레딧 정산금액 : ${addCommasToNumber(summary.paid)}
          </div>
        </Col>
      </Row>

      <Nav tabs className="mb-3 bg-light">
        {["크레딧 사용", "크레딧 정산"].map((tab) => (
          <NavItem key={tab}>
            <NavLink
              className={activeTab === tab ? "active" : ""}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      <Container style={{ marginLeft: "0px" }}>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="크레딧 사용" className="border-0">
            <AdminCreditHistoryUsed isActive={activeTab === "크레딧 사용"} />
          </TabPane>
          <TabPane tabId="크레딧 정산" className="border-0">
            <AdminCreditHistoryPaid isActive={activeTab === "크레딧 정산"} />
          </TabPane>
        </TabContent>
      </Container>
    </>
  );
}

export default AdminCredit;
